import Vue from 'vue';
import DhxCalendar from '@/components/Dhx/DhxCalendar.vue'

export default Vue.extend({
    components: {
      DhxCalendar
    },
    data: function () {
    return {
      date: undefined,
      disable: false,
      config: {}
    };
  },
  watch: {
    'value': {
      immediate: true,
      deep: true,
      handler(value) {
        this.$nextTick(() => {

          this.date = this.params.value

          if(this.params.colDef.cellRendererParams !== undefined){
            this.disable = this.params.colDef.cellRendererParams.disable
          }
        })        
      }
    }
  },
  methods: {
    apply() {      
      let colId = this.params.column.colId

      this.params.node.setDataValue(colId, this.date);
    }
  },
  template: `
        <dhx-calendar class="calendar" v-model="date" :config="config" @input="apply" :disabled="disable"/>
    `,  
});